document.addEventListener('click', function (e) {
  var btn = e.target.closest('.slider-button--prev, .slider-button--next');
  if (!btn) return;

  var viewer = btn.closest('[id^="GalleryViewer-"]');
  if (!viewer) return;

  var gallery = btn.closest('media-gallery');
  if (!gallery) return;

  e.preventDefault();
  e.stopImmediatePropagation();

  var isNext = btn.classList.contains('slider-button--next');
  var slides = Array.from(viewer.querySelectorAll('.product__media-item.slider__slide')).filter(function(s) { return s.style.display !== 'none'; });
  if (!slides.length) return;

  var cur = slides.findIndex(function (s) { return s.classList.contains('is-active'); });
  if (cur < 0) cur = 0;
  var target = slides[(cur + (isNext ? 1 : -1) + slides.length) % slides.length];
  var mediaId = target.dataset.mediaId;

  var thumbsEl = gallery.querySelector('[id^="GalleryThumbnails-"]');
  if (thumbsEl && mediaId) {
    var li = thumbsEl.querySelector('[data-target="' + mediaId + '"]');
    if (li) {
      var thumbBtn = li.querySelector('button.thumbnail');
      if (thumbBtn) { thumbBtn.click(); return; }
    }
  }

  // fallback: toggle is-active directly
  slides.forEach(function (s) { s.classList.remove('is-active'); });
  target.classList.add('is-active');
}, true);
